import { render } from "./TopAnalytics.vue?vue&type=template&id=2f5d2c2d"
import script from "./TopAnalytics.vue?vue&type=script&lang=js"
export * from "./TopAnalytics.vue?vue&type=script&lang=js"
script.render = render

export default script